{
  "entitySuggestion": {
    "duplicates": {
      "heading": {
        "system": "Ce système existe peut-être déjà",
        "orgFunction": "Cette Fonction existe peut-être déjà"
      },
      "useThisInstead": {
        "system": "Utiliser ce système",
        "orgFunction": "Utiliser cette Fonction"
      },
      "reasons": {
        "same_category": "Même catégorie",
        "same_department": "Même département"
      },
      "linkError": "Impossible de lier la suggestion. Veuillez réessayer.",
      "checking": "Recherche de doublons…"
    },
    "kind": {
      "system": "Système",
      "orgFunction": "Fonction"
    },
    "system": {
      "dialog": {
        "title": "Proposer un système",
        "description": "Un administrateur examinera votre proposition et ajoutera le système.",
        "name": "Nom du système",
        "description_field": "Description",
        "category": "Catégorie",
        "categoryHint": "De quel type de système s'agit-il le plus probablement ? p. ex. CRM / ERP / HCM",
        "url": "Lien vers le site web du fournisseur",
        "submit": "Proposer"
      },
      "card": {
        "pendingBadge": "Proposé"
      }
    },
    "orgFunction": {
      "dialog": {
        "team": {
          "title": "Proposer une équipe",
          "description": "Un administrateur examinera votre proposition et créera l'équipe.",
          "name": "Nom de l'équipe"
        },
        "role": {
          "title": "Proposer une fonction",
          "description": "Un administrateur examinera votre proposition et créera la fonction.",
          "name": "Nom de la fonction / du rôle / de l'équipe"
        },
        "description_field": "Description",
        "department": "Département",
        "departmentHint": "Dans quel département la fonction est-elle le mieux située ?",
        "email": "E-mail",
        "submit": "Proposer"
      },
      "card": {
        "pendingBadge": "Proposé"
      }
    },
    "review": {
      "titleSystem": "Examiner la proposition de système",
      "titleTeamSuggestion": "Examiner la proposition d'équipe",
      "titleFunctionSuggestion": "Examiner la proposition de fonction",
      "descriptionSystem": "Ajouter {{name}} comme nouveau système au catalogue, ou le fusionner avec un système existant.",
      "descriptionTeamSuggestion": "Ajouter {{name}} comme nouvelle équipe au catalogue, ou la fusionner avec une équipe existante.",
      "descriptionFunctionSuggestion": "Ajouter {{name}} comme nouvelle fonction au catalogue, ou la fusionner avec une fonction existante.",
      "createAsNew": {
        "system": "Créer comme nouveau système",
        "team": "Créer comme nouvelle équipe",
        "function": "Créer comme nouvelle fonction"
      },
      "titleApproveSystem": "Approuver et créer le système",
      "titleApproveTeam": "Approuver et créer l'équipe",
      "titleApproveFunction": "Approuver et créer la fonction",
      "descriptionApproveSystem": "Créer {{name}} comme nouveau système et approuver la proposition. Les enregistrements qui y faisaient référence pointeront vers le nouveau système.",
      "descriptionApproveTeam": "Créer {{name}} comme nouvelle équipe et approuver la proposition. Les enregistrements qui y faisaient référence pointeront vers la nouvelle équipe.",
      "descriptionApproveFunction": "Créer {{name}} comme nouvelle fonction et approuver la proposition. Les enregistrements qui y faisaient référence pointeront vers la nouvelle fonction.",
      "approveAndCreate": "Approuver et créer",
      "proposedDetails": {
        "headingSystem": "Système proposé",
        "headingTeam": "Fonction proposée",
        "name": "Nom",
        "kind": "Type",
        "category": "Catégorie",
        "url": "URL",
        "description": "Description",
        "department": "Département",
        "email": "E-mail"
      },
      "mergeWithExistingSection": {
        "system": "Fusionner plutôt avec un système existant",
        "orgFunction": "Fusionner plutôt avec une Fonction existante"
      },
      "mergeSelectPlaceholder": {
        "system": "Choisir un système existant…",
        "orgFunction": "Choisir une Fonction existante…"
      },
      "confirmMerge": {
        "title": {
          "system": "Fusionner avec un système existant ?",
          "orgFunction": "Fusionner avec une Fonction existante ?"
        },
        "description": {
          "system": "« {{suggestionName}} » sera fusionné avec « {{targetName}} ». L'enregistrement source pointera ensuite vers le système existant. Cette action est irréversible.",
          "orgFunction": "« {{suggestionName}} » sera fusionné avec « {{targetName}} ». L'enregistrement source pointera ensuite vers la Fonction existante. Cette action est irréversible."
        },
        "confirm": "Fusionner"
      },
      "reject": "Rejeter",
      "approved": "Proposition approuvée",
      "rejected": "Proposition rejetée",
      "merged": "Proposition fusionnée",
      "sourceRecording": "Proposé dans",
      "submittedBy": "Soumis par",
      "submittedAt": "Soumis le",
      "confirmReject": {
        "title": "Rejeter la proposition ?",
        "description": "La proposition sera rejetée et ne sera pas ajoutée à la base de connaissances. Veuillez indiquer un motif."
      },
      "fields": {
        "rejectionReason": "Motif du rejet"
      },
      "placeholders": {
        "rejectionReason": "Expliquez brièvement pourquoi cette proposition est rejetée"
      }
    }
  }
}
